<template>
  <div>
    <table class="table">
      <tr>
        <th>{{$t('lang.particulars.DeviceName')}} <i class="el-icon-edit" /></th>
        <td v-if="list.deviceName&&!DeviceInfo.show" @dblclick="DeviceInfoShow()">{{list.deviceName}}</td>
        <td v-else-if="DeviceInfo.show">
          <el-input 
            v-model="DeviceInfo.deviceName"
            @keyup.enter.native="UpDeviceName()"
            @blur="UpDeviceName()"
          ></el-input>
        </td>
        <td v-else-if="!DeviceInfo.show" @dblclick="DeviceInfoShow()">
          N/A
        </td>
        <!-- <td v-else>N/A</td> -->
        <th>{{$t('lang.particulars.Grouping')}}</th>
        <td v-if="list.gname">{{list.gname}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.Professional')}}</th>
        <td v-if="list.deviceSystemName">{{list.deviceSystemName}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.Models')}}</th>
        <td v-if="list.deviceRouteModel">{{list.deviceRouteModel}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.Version')}}</th>
        <td v-if="list.deviceSoftwareVer">{{list.deviceSoftwareVer}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.Kernel')}}</th>
        <td v-if="list.deviceKerVer">{{list.deviceKerVer}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.Product')}}</th>
        <td v-if="list.deviceProductName">{{list.deviceProductName}}</td>
        <td v-else-if="list.deviceModel">{{list.deviceModel}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.Serial')}}</th>
        <td v-if="list.deviceSn">{{list.deviceSn}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.Hardware')}}</th>
        <td v-if="list.deviceSn.includes('SS')&&SsPsShow">{{$t('lang.particulars.SerialServer')}}</td>
        <td v-else-if="list.deviceSn.includes('PS')&&SsPsShow">{{$t('lang.particulars.PrintServer')}}</td>
        <td v-else-if="list.deviceHardwareType==1&&!SsPsShow">{{$t('lang.particulars.blendmode')}} SMSC</td>
        <td
          v-else-if="list.deviceHardwareType==2&&!SsPsShow"
        >{{$t('lang.particulars.discard_year')}} SMDC</td>
        <td v-else-if="list.deviceHardwareType==3&&!SsPsShow">{{$t('lang.particulars.model_id')}} DMDC</td>
        <td
          v-else-if="list.deviceHardwareType==4&&!SsPsShow"
        >{{$t('lang.particulars.MultiSimVariants')}} MMMC</td>
        <td v-else-if="list.deviceHardwareType==5&&!SsPsShow">DTU</td>
        <td v-else-if="list.deviceHardwareType==6&&!SsPsShow">RTU</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.hardware')}}</th>
        <td v-if="list.deviceHardwareVer">{{list.deviceHardwareVer}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.mac')}}</th>
        <td v-if="list.deviceMac">{{list.deviceMac}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.network')}}</th>
        <td v-if="list.deviceNetworkMode==1">{{$t('lang.particulars.Modeling')}}</td>
        <td v-else-if="list.deviceNetworkMode==2">{{$t('lang.particulars.G3G4')}}</td>
        <td v-else-if="list.deviceNetworkMode==3">{{$t('lang.particulars.compatibility')}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <!-- <th>{{$t('lang.particulars.VendorModel')}}</th>
        <td v-if="list.vname">{{list.vname}}</td>
        <td v-else>N/A</td>-->
        <th>{{$t('lang.particulars.deviceID')}}</th>
        <td v-if="list.deviceDid">{{list.deviceDid}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.Customer')}}</th>
        <td v-if="list.customer">{{list.customer}}</td>
        <td v-else>N/A</td>
      </tr>
      <tr>
        <th>{{$t('lang.particulars.ADDRESS')}}</th>
        <td v-if="list.deviceBlock">{{list.deviceBlock}}</td>
        <td v-else>N/A</td>
        <th>{{$t('lang.particulars.detailed')}} <i class="el-icon-edit" /></th>
        <td v-if="list.deviceAddress&&!DeviceInfo.show" @dblclick="DeviceInfoShow()"
        >{{list.deviceAddress}}</td>
        <td v-else-if="DeviceInfo.show">
          <el-input v-model="DeviceInfo.deviceAddress"
          @keyup.enter.native="UpDeviceAddress()"
          @blur="UpDeviceAddress()"
          ></el-input>
        </td>
        <td v-else-if="!DeviceInfo.show" @dblclick="DeviceInfoShow()">N/A</td>
      </tr>
      <tr v-if="list.deviceLevelupTime">
        <th>{{$t('lang.particulars.UpgradeTime')}}</th>
        <td>{{list.deviceLevelupTime}}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import { showDeviceDetail, updateDevice,updateDeviceAddress,updateDeviceName } from "@/api/particulars";
export default {
  props: ['list', 'SsPsShow'],
  data() {
    return {
      //设备名称与设备地址修改
      DeviceInfo:{
        show:false,
        deviceName:'',
        id:'',
        deviceAddress:''
      },
    }
  },
  methods: {
    //修改设备名称与设备地址
    DeviceInfoShow(){
      this.DeviceInfo.show=true
      this.DeviceInfo.deviceAddress=this.list.deviceAddress
      this.DeviceInfo.deviceName=this.list.deviceName?this.list.deviceName:''
      this.DeviceInfo.id=this.list.deviceId
    },
    UpDeviceName(){
      updateDeviceName(this.DeviceInfo.id,this.DeviceInfo.deviceName)
      .then((res)=>{
        if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message15"),
                type: "success"
              });
              this.DeviceInfo.show=false
              this.$emit('showDeviceDetail')
              // this.showDeviceDetail();
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message16"),
                type: "warning"
              });
            }
      })
    },
    UpDeviceAddress(){
      updateDeviceAddress(this.DeviceInfo.id,this.DeviceInfo.deviceAddress)
      .then((res)=>{
        if (res.data.code === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message15"),
                type: "success"
              });
              this.DeviceInfo.show=false
              this.$emit('showDeviceDetail')
              // this.showDeviceDetail();
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.particulars.message16"),
                type: "warning"
              });
            }
      })
    },
    // UpDeviceNameAndAddress(){
    //   updateDevice(this.DeviceInfo.id,this.DeviceInfo.deviceName,this.DeviceInfo.deviceAddress)
    //   .then((res)=>{
    //     if (res.data.code === 0) {
    //           this.$message({
    //             showClose: true,
    //             message: this.$t("lang.particulars.message15"),
    //             type: "success"
    //           });
    //           this.DeviceInfo.show=false
    //           this.$emit('showDeviceDetail')
    //           // this.showDeviceDetail();
    //         } else {
    //           this.$message({
    //             showClose: true,
    //             message: this.$t("lang.particulars.message16"),
    //             type: "warning"
    //           });
    //         }
    //   })
    // }
  }
}
</script>
<style scoped src='./particulars.css'></style>